import { lazy } from 'react';
import { wrapNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const ReferralGiftingSendGiftFlowPageContent = lazy(
  () => import('./ReferralGiftingSendGiftFlowPageContent'),
);

export const ReferralGiftingSendGiftFlowPage = wrapNavigatorScreen(
  () => {
    return <ReferralGiftingSendGiftFlowPageContent />;
  },
  {
    cardOverlayEnabled: true,
    animationEnabled: false,
    detachPreviousScreen: false,
    cardStyle: {
      backgroundColor: 'transparent',
    },
    headerShown: false,
  },
);
